export default "__VITE_ASSET__59c10318__"